const factory = require('./factory')

module.exports = factory()
